export default __webpack_public_path__ + "static/media/9294 - DegenSherpa.67d9da08.jpeg";